const api = {
  purchaser: {
    // 判断两个采购品类对应的模板是否相同
    templateIsSame: {
      url: '/mall/purCategorySubmitTemp/templateIsSame',
      type: 'post'
    }
  },
  mall: {
    // 判断两个采购品类对应的模板是否相同
    templateIsSame: {
      url: '/mall/purCategorySubmitTemp/templateIsSame',
      type: 'post'
    }
    
  },
  supplier: {
   
  }
}
export default api[window.fe.project]
